import { ChangeDetectorRef, Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ObjFilter } from '@app/components/tools/ObjFilter';
import { HotelsFilters } from '@app/models/filtermodels/HotelsFilters';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Hotel } from '@app/models/hotels/Hotel';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { TrafficsService } from '@app/services/traffics.service';
import moment from 'moment';

@Component({
    selector: 'app-ziel',
    templateUrl: './ziel.component.html',
    styleUrl: './ziel.component.scss',
    standalone: false
})
export class ZielComponent implements OnInit {
    @Input() item: any;
    fixinfo: boolean = false;
    hotel: Hotel;

    dauer: string;
    image: string;

    categoryAr: number[] = [];
    destRef = inject(DestroyRef);
    loading: boolean = false;
    isOpenLink: boolean = false;

    partner: Partner;

    filtersData: HotelsFilters;
    higherPricePr: string = '';

    higherPrice: number = 0;
    curprice: number = 0;
    realparams: ParamFilters = {} as ParamFilters;

    constructor(
        protected guardService: AuthGuardService,
        private cdr: ChangeDetectorRef,
        private trafficsService: TrafficsService,
    ) { }

    ngOnInit(): void {
        this.initAuth();
    }

    async getReiseDauer() {
        this.dauer = this.hotel?.offerList?.[0]?.travelDate?.duration + '';
        if (this.dauer?.length > 0) {
            this.dauer += ' Tage,'
        }
    }

    initAuth(): void {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destRef)
        ).subscribe(partner => {
            if (partner?.partnerid?.length > 0) {
                this.partner = partner;
                this.image = this.item.image;
                if (this.item?.inputData?.realparams) {
                    this.filtersData = {} as HotelsFilters;
                    if(!this.item?.customtext) {
                        this.initFilters();
                    }
                } else {
                    // this.openEditor();
                }
            }
        });
    }

    initFilters(): void {
        if (this.item.inputData?.realparams) {
            this.realparams = this.item.inputData?.realparams;
            const myobj = new ObjFilter(this.realparams, this.item.inputData?.limit, this.partner.agenturen);
            this.filtersData = myobj.initFilters();
            this.gethotels();
        } else {
            this.loading = false;
        }
    }

    openImageTemplate() {
        this.isOpenLink = true;
    }

    async getGiataMedia(giataId) {
        if (giataId?.length > 0) {
            this.loading = true;
            this.trafficsService.request({ giataId: giataId }, 'hotels/giataId').pipe(
                takeUntilDestroyed(this.destRef)
            ).subscribe((res) => {
                if (res.hotel) {
                    if (res?.hotel?.category?.length > 0) {
                        const catg = Number(String(res?.hotel?.category).replace(/,/g, '.'));
                        this.categoryAr = [];
                        for (let i = 0; i < Math.floor(catg); i++) {
                            this.categoryAr.push(1);
                        }
                        if (catg > Math.floor(catg)) {
                            this.categoryAr.push(0.5);
                        }
                    }
                    this.hotel.catalogData = res?.hotel?.catalogData;
                    if (!(this.item.image?.length > 0)) {
                        this.image = res?.hotel?.catalogData.imageList[0];
                    }
                }
                this.loading = false;
                this.cdr.detectChanges();
            });
        }
    }

    async gethotels() {
        this.loading = true;
        this.trafficsService.request(this.filtersData, 'hotels').pipe(
            takeUntilDestroyed(this.destRef)
        ).subscribe((res) => {
            if (res?.hotelList?.length > 0) {
                this.hotel = res.hotelList[0];
                if(this.item?.inputData?.realparams?.pauschalreiseResult?.type === 1) {
                    this.getGiataMedia(this.hotel.giata.hotelId);
                }
                this.getReiseDauer();
                this.checkRed();
            }
            this.loading = false;
            this.cdr.detectChanges();
        });
    }

    async checkRed() {
        if (this.hotel?.offerList?.length > 0) {
            this.higherPrice = this.getMaxPrice(this.hotel.offerList);
            if (!isNaN(Number(this.higherPrice)) && !isNaN(Number(this.hotel?.bestPricePerPerson?.value))) {
                this.curprice = Number(this.hotel?.bestPricePerPerson?.value);
                const prc = 100 - (Number(100 * Number(this.hotel?.bestPricePerPerson?.value)) / Number(this.higherPrice));
                if (prc >= 15 && prc <= 55) {
                    this.higherPricePr = (prc).toFixed(0);
                } else {
                    this.higherPrice = null;
                }
            }
        }
    }

    getMaxPrice(list: any[]): number {
        let max = 0;
        for (let i = 0; i < list.length; i++) {
            if (max < Number(list[i].personPrice.value)) {
                max = Number(list[i].personPrice.value);
            }
        }
        return max;
    }
}
